import API from '@/lib/API.js'
import comun from './comun.js'
const efectores = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, valor) {
            state.Lista = valor;
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        select({
            commit
        }, valor) {
            commit("select", valor)
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_tipo_afiliacion: 0,
                descripcion_afiliacion: ""
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_tipo_afiliacion != 0) {
                data = await API.Efector.modificar(state.Seleccionado);
                str += "Efector modificado"
            } else {
                data = await API.Efector.alta(state.Seleccionado);
                str += `Nuevo Efector de alta'${data.descripcion_afiliacion}'`
            }
            commit("select", data)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_tipo_afiliacion != 0) {
                data = await API.Efector.modificar(entidad);
                str += "Efector modificado"
            } else {
                data = await API.Efector.alta(entidad);
                str += `Nuevo Efector de alta'${data.descripcion_afiliacion}'`
            }
            let entidades = await API.Efector.traerTodos();
            commit("set", entidades)
            dispatch("selectPorId", data.id_tipo_afiliacion)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Efector.eliminar(id);
                str += "Efector eliminada"
            }
            let ents = await API.Efector.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
        async AgregarPlan({
            state
        }, id_plan) {
            let p = await API.Efector_Plan.alta({
                id_Efector: state.Seleccionado.Id,
                Id_Plan: id_plan
            });
            state.Seleccionado.Efector_Plan.push(p)
        },
        async QuitarPlan({
            state
        }, id_plan) {
            await API.Efector_Plan.eliminar({
                id_Efector: state.Seleccionado.Id,
                Id_Plan: id_plan
            });
            state.Seleccionado.Efector_Plan = state.Seleccionado.Efector_Plan.filter((x) => x.Id_Plan !== id_plan)
        },
    },
    modules: {
        comun,
    }
}
export default efectores;